import React, { FC, useState } from 'react';

// Shared UI Library Components
import { CustomIcon, EIconName, Loader } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './service-revenue.scss';

// Components
import { TotalRangeItem } from '../total-range-item/total-range-item';

// Models
import { IIncomeCharts } from '../../../../interfaces/dashboard.interfaces';
import { ICurrency } from '../../../../interfaces/company.interfaces';

type TServiceRevenueProps = {
  currency: ICurrency,
  income_charts?: IIncomeCharts,
  loading?: boolean,
};

export const ServiceRevenue: FC<TServiceRevenueProps> = (
  {
    currency,
    income_charts: { audio_calls, video_calls, paid_messages, conversations } = {
      audio_calls: 0,
      video_calls: 0,
      paid_messages: 0,
      conversations: 0
    },
    loading = false
  }: TServiceRevenueProps
) => {

  const [hideBlock, setHideBlock] = useState<boolean>(false);

  const totalRevenue = (video_calls + audio_calls + paid_messages + conversations) || 100;

  const toggleHideBlockState = (): void => {
    setHideBlock(!hideBlock);
  }

  return (
    <div className="service-revenue">
      <div className="service-revenue--header">
        <div className="header-title">
          Service Revenue by Consultation Type
        </div>
        <div className={ `header-action header-action--${ hideBlock ? 'open' : 'hide' }` }
             onClick={ toggleHideBlockState }>
          { hideBlock ? 'Show' : 'Hide' } <CustomIcon size={ 'size-md' } name={ EIconName.ArrowDown }/>
        </div>
      </div>

      { loading && <div className="service-revenue--loader">
        <Loader size={ 'large' }/>
      </div> }

      <div className="service-revenue--content" hidden={ hideBlock }>
        <TotalRangeItem data={ [totalRevenue, video_calls] } colors={ ['#f2f3f4', '#21917F'] }>
          <CustomIcon name={ EIconName.CameraOn } skipSize={ true }/> { currency.symbol }{ video_calls }
        </TotalRangeItem>
        <TotalRangeItem data={ [totalRevenue, audio_calls] } colors={ ['#f2f3f4', '#21917F'] }>
          <CustomIcon name={ EIconName.MicOn } skipSize={ true }/> { currency.symbol }{ audio_calls }
        </TotalRangeItem>
        <TotalRangeItem data={ [totalRevenue, conversations] } colors={ ['#f2f3f4', '#21917F'] }>
          <CustomIcon name={ EIconName.Chat } skipSize={ true }/> { currency.symbol }{ conversations }
        </TotalRangeItem>
        <TotalRangeItem data={ [totalRevenue, paid_messages] } colors={ ['#f2f3f4', '#21917F'] }>
          <CustomIcon name={ EIconName.Message } skipSize={ true }/> { currency.symbol }{ paid_messages }
        </TotalRangeItem>
      </div>
    </div>
  );
}
